<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-mac-address-attribute-dialog"
      :open.sync="openDialog"
      :form-ref.sync="macAddressAttributeFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer une adresse MAC</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-text-field
          v-model="attributeForm.value"
          label="Adresse MAC"
          :rules="rules.valueRules"
          persistent-hint
          hint="Format 12:34:56:AB:CD:EF ou 12-34-56-AB-CD-EF"
        >
        </v-text-field>
        <v-textarea v-model="attributeForm.comment" label="Commentaire">
        </v-textarea>
        <p>
          Les commentaires sont utilisés pour savoir par qui et pour quelle
          raison l'attribut a été ajouté
        </p>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { toRefs, onMounted, computed } from "@vue/composition-api";
import { useAttributes } from "@/composables/attribute";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    clientPortal: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { attributeData, createMacAddressAttribute } = useAttributes();

    /* Variables */

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      attributeData.attributeForm.name = "MAC-ADDRESS";
      attributeData.rules.valueRules.push(
        (v) =>
          (v && /^([0-9A-Fa-f]{2}[-:]){5}([0-9A-Fa-f]{2})$/.test(v)) ||
          "format invalide"
      );
    });

    /* Méthodes */
    const saveItem = async function () {
      await createMacAddressAttribute(props.clientPortal.id);
      openDialog.value = attributeData.createMacAdressAttributeDialog;
    };

    return {
      createMacAddressAttribute,
      ...toRefs(attributeData),
      saveItem,
      openDialog,
    };
  },
};
</script>
